export const BASE_URLs = 'https://newtestapi.paropakari.com/api/';